// @ts-nocheck
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
// import Button, { ButtonPresentationProps } from "@insite/mobius/Button"; // Store Custom Code
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { FC } from "react";
import { useSelector } from "react-redux";

/* Store Custom Code - Start */
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
/* Store Custom Code - End */

const SignInToSeePriceButton: FC<ButtonPresentationProps> = ({ ...buttonProps }) => {
    const history = useHistory();
    const state = useSelector((state: ApplicationState) => {
        return {
            currentLocation: getLocation(state),
            signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        };
    });

    const signInHandler = () => {
        if (!state.signInUrl) {
            logger.warn("No url was found for SignInPage, defaulting to /SignIn");
            history.push("/MyAccount/SignIn");
        } else {
            const returnUrl = state.currentLocation.pathname + state.currentLocation.search;
            if (returnUrl === "/") {
                history.push(`${state.signInUrl}`);
            } else {
                history.push(`${state.signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}`);
            }
        }
    };

    return (
        <Button {...buttonProps} onClick={signInHandler}>
            {translate("Sign in to see price")}
        </Button>
    );
};

export default SignInToSeePriceButton;
